<template>
<div class="mb-12">
    <label for="timezone">
        {{ label }} <span class="text-red">*</span>
    </label>
    <select
        name="timezone"
        @change="selectTimeZone">
        <option
            v-for="timezone in zones"
            :selected="timezone === value">{{ timezone }}</option>
    </select>
    <span v-show="errors.has('timezone')" class="error text-error-red text-lg">{{ errors.first('timezone') }}</span>
</div>
</template>

<script>

    import moment from 'moment-timezone';

    export default {
        name: 'TimeZones',
        props: {
            label: String,
            value: String
        },
        components:{},
        data: () => ({
            zones: moment.tz.names()
        }),
        computed: {},
        watch: {},
        methods: {
            selectTimeZone(event) {
                this.$emit('input', event.target.value)
            }
        },
        mounted() {}
    }
</script>
